import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { BookingRequestForm } from "@/components/BookingRequestForm";

export default function Book() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main data-testid="book-page" className="min-h-screen bg-[#060b14] text-white">
      <header className="border-b border-white/10">
        <div className="max-w-[1200px] mx-auto px-6 md:px-12 h-[72px] flex items-center justify-between">
          <Link
            to="/"
            data-testid="book-back-link"
            className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-white/70 hover:text-white transition-colors"
          >
            <ArrowLeft size={14} /> Back to site
          </Link>
          <span className="font-display uppercase text-xl tracking-tight">
            Coast<span className="text-[#2a5fdb]">2</span>Coast
          </span>
        </div>
      </header>

      <div className="max-w-[1200px] mx-auto px-6 md:px-12 py-16 md:py-24">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <div className="chapter-num mb-6">Book a session</div>
          <h1 className="font-display uppercase text-5xl md:text-7xl leading-[0.9] tracking-tight">
            Request <span className="text-[#2a5fdb]">a session.</span>
          </h1>
          <p className="mt-5 text-white/60 max-w-xl text-sm md:text-base leading-relaxed">
            Fill in the quick form below and Owen will text you back to lock in
            session times — all sessions run 60 minutes in the eastern suburbs.
          </p>
        </motion.div>

        <div className="mt-14">
          <BookingRequestForm />
        </div>
      </div>
    </main>
  );
}
